import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const KidsIcon: FC<IconProps> = ({ width = 41, height = 32, ...rest }) => (
  <Icon type="Kids" width={width} height={height} alt="kids" {...rest} />
)
